import { httpRequest, makeRequestURL } from 'common'

import { IGetPrivacyCenterComponentsRequest, IGetPrivacyCenterContentResponse } from '../types'
import { getPrivacyCenterContentEndpoint } from '../utils'

const getPrivacyCenterComponentsRemote = ({
  country,
  accountType,
  entity,
  language,
}: IGetPrivacyCenterComponentsRequest) => {
  const url = makeRequestURL(
    getPrivacyCenterContentEndpoint?.url ?? '',
    {
      country,
      accountType,
      entity,
      language,
    },
    '.json',
  )

  return httpRequest<IGetPrivacyCenterContentResponse<typeof entity, typeof accountType>>(
    {
      ...getPrivacyCenterContentEndpoint,
      url,
    },
    {
      country,
      userType: accountType,
      entity,
      language,
    },
  )
}

export { getPrivacyCenterComponentsRemote }
